<template>
    <div class="custom-image" ref="root">
        <input
            type="file"
            ref="fileInput"
            accept="image/*"
            class="form-upload"
            @change="onFileSelected"
        />
        <label @click="$refs['fileInput'].click()">
            <i class="fa fa-upload"></i>
            <template v-if="value"> {{ t('custom_image-change') }} </template>
            <template v-if="!value"> {{ t('custom_image-get_from_computer') }} </template>
        </label>
        <template v-if="value">
            <span class="limpar" @click="clean">{{ t('custom_image-clean') }}</span>
        </template>
    </div>
</template>
<script>
import keviApi from "../../keviApi";
export default {
    name: "custom-image",
    props: {
        value: {
            type: String,
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        clean: function () {
            this.$emit("input", null);
        },
        onFileSelected: function (event) {
            let formData = new FormData();

            for (let i in event.target.files) {
                formData.append("image", event.target.files[i]);
            }

            let options = keviApi.getOptions("upload-image");
            options.headers["Content-Type"] = "multipart/form-data";

            this.$http
                .post(options.url, formData, { headers: options.headers })
                .then(
                    (response) => {
                        this.$emit("input", response.body.value);
                        this.$emit("cleanImageError", null);
                    },
                    function (error) {
                        console.error(error.statusText);
                    },
                );

            this.$refs.fileInput.value = "";
        },
    },
};
</script>
